import find from 'lodash/find'
import get from 'lodash/get'
import filter from 'lodash/filter'

const getters = {
  selectedApplication: state => {
    return state.application ? state.application : null
  },
  applicationCompany: state => {
    return state.company ? state.company : null
  },
  applicationProfession: state => {
    return state.profession ? state.profession : null
  },
  applicationEmployee: state => {
    return state.employee ? state.employee : null
  },
  applicationCompanyEmployments: state => {
    return state.companyEmployments ? state.companyEmployments : null
  },
  applicationOrders: state => {
    return state.orders ? state.orders : null
  },
  applicationDistanceEductions: state => {
    return state.distanceEducations ? state.distanceEducations : null
  },
  applicationWorkplace: state => {
    return state.workplace ? state.workplace : null
  },
  applicationDepartments: state => {
    return state.departments ? state.departments : null
  },
  applicationDepartment: state => {
    return state.department ? state.department : null
  },
  isCompanyApplication: state => {
    return state.application ? Boolean(state.application.isCompanyApplication) : null
  },
  canBeEdited: (state, getters, rootState, rootGetters) => {
    const states = rootGetters['basic/basicStates']
    const appstate = find(states, ['id', get(state, 'application.stateId', -1)])
    if (!appstate) {
      return false
    }
    return ['draft', 'confirmedByStudent', 'confirmedByCompany', 'confirmedAndApprovedByCompany'].includes(
      appstate.state
    )
  },
  approvedStateByCompany: (state, getters, rootState, rootGetters) => {
    const states = rootGetters['basic/basicStates']
    const confirmedAndApprovedByCompanyIds = filter(states, ['state', 'confirmedAndApprovedByCompany']).map(s => s.id)

    return confirmedAndApprovedByCompanyIds.includes(get(state, 'application.stateId', null))
  }
}

export default getters
